export enum AuthorizedFileFormatEnum {
    MP4 = 'video/mp4'
  }
  